// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

const getSegmentsFromBounds = (bounds = []) => bounds.reduce((acc, bound) => acc.concat(bound.segments.map(segment => ({
  ...segment
}))), []).map((segment, index) => ({
  ...segment,
  segmentIndex: index
}));
const MILLISECONDS_PER_MINUTE = 60 * 1000;
export const getIsShorterTransferTime = (bounds = [], minimumConnectionTime) => {
  const eventSegments = getSegmentsFromBounds(bounds).filter(segment => segment.__typename === 'EventSegment');
  const durations = eventSegments.map(eventSegment => eventSegment.duration).filter(duration => typeof duration === 'number');
  if (durations.length === 0) {
    return false;
  }
  const leastDuration = Math.min(...durations);
  const minimumConnectionTimeInMs = minimumConnectionTime * MILLISECONDS_PER_MINUTE;
  return leastDuration < minimumConnectionTimeInMs;
};
//# sourceMappingURL=transferTimeUtils.js.map